import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import StyleTooltip from './StyleTooltip';

const StatisticBox = ({ topic, tooltip, numerator, denominator }) => {

  const formatNumber = (number) => {
    return number ? number.toLocaleString() : "0";  // Formats the number with thousand separators
  };

  return (
    <Box
      sx={{
        width: "300px",
        border: "1px solid #148a01",
        margin: "5px",
        borderRadius: "5px",
        padding: "10px",
        display: 'flex',
        justifyContent: 'space-between', // Adjust to space-between to align items on opposite ends
        alignItems: 'center'
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",

        }}
      >
        <StyleTooltip title={tooltip}>
          <Typography
            style={{
              marginBottom: "10px !important",
              textAlign: "left",
              font: "normal normal 550 13px/18px Open Sans",
              color: "black",
              fontSize: '14px'
            }}
          >
            {topic}
          </Typography>
        </StyleTooltip>
      </div>
      <StyleTooltip title={tooltip}>
        <Typography variant="subtitle1" component="span" sx={{ fontWeight: 'bold' }}>
          {numerator > 0 ? `${formatNumber(numerator)} / ${formatNumber(denominator)}` : formatNumber(denominator)}
        </Typography>
      </StyleTooltip>
    </Box>
  );
};

export default StatisticBox;
